<template>
  <v-select
    v-model="item"
    dir="rtl"
    :multiple="multiple"
    label="Title"
    :reduce="x => x.Id"
    :options="items"
    :clearable="clearable"
    :loading="loading"
    :selectable="x => unselectable.includes(x.Id) === false || x.Id === val"
    @open="onOpen"
  >
    <span
      slot="no-options"
      @click="$refs.select.open = false"
    >
      موردی یافت نشد
    </span>
    <template #spinner>
      <div class="demo-inline-spacing">
        <b-spinner
          v-if="loading"
          class="m-0"
          small
          variant="secondary"
        />
      </div>
    </template>
  </v-select>
</template>

<script>

import vSelect from 'vue-select'
import { mapState } from 'vuex'

export default {
  name: 'Coupon',
  components: {
    vSelect,
  },
  props: {
    value: {
      type: [String, Number, Array],
      default: null,
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    isDynamic: {
      type: Boolean,
      default: null,
    },
    unselectable: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      val: this.value,
      loading: false,
    }
  },
  watch: {
    value(v) {
      this.val = v
    },
  },
  computed: {
    ...mapState('zirehState', { items: state => state.couponSelect }),
    ...mapState('zirehState', { flag: state => state.couponSelectFlag }),
    item: {
      get() {
        if (this.value && (this.value.length || this.multiple === false)) {
          this.get()
        }
        return this.val
      },
      set(newValue) {
        this.$emit('input', newValue)
        this.val = newValue
      },
    },
  },
  methods: {
    get() {
      if (this.flag === false && this.items.length === 0) {
        this.$store.commit('zirehState/setCouponSelectFlag', true)
        this.loading = true
        this.$http.post(
          this.$api.coupon.getall, {},
        )
          .then(res => {
            let { data } = res

            if (this.isDynamic === true || this.isDynamic === false) {
              data = data.filter(x => x.IsDynamic == this.isDynamic)
            }

            this.$store.commit('zirehState/setCouponSelect', data)
            this.loading = false
          })
      }
    },
    onOpen() {
      this.get()
    },
  },
}
</script>
